/**
 *
 * @param value 传入值
 * @param fix 小数位数
 * @param intDecimal 整数是否取小数
 * @return {string|*}
 */
export function priceFormat (value, fix = 2, intDecimal = true) {
  if (isNaN(value)) {
    return value
  }

  let num = Number(value)

  const re = /(-?\d+)(\d{3})/
  if (Number.prototype.toFixed) {
    if (num % 1 !== 0 || intDecimal) {
      num = (num).toFixed(fix) // 四舍五入
    }
  } else {
    num = Math.round(num * 100) / 100
  }
  num = '' + num
  while (re.test(num)) {
    num = num.replace(re, '$1,$2')
  }

  return num
}

export function largePriceFormat (value) {
  if (isNaN(value)) {
    return value
  }
  let num = Number(value)
  if (num >= 10000) {
    const digit = Math.floor((num % 10000) / 1000)
    if (digit !== 0) {
      return `${Math.floor(num / 10000)}.${digit}万`
    } else {
      return `${Math.floor(num / 10000)}万`
    }
  }
  return num
}
